/* eslint no-useless-escape: "warn" */

window.addEventListener('load', () => {
  const data = {
    results: [
      {
        id: 'us',
        text: 'US',
      },
      {
        id: 'sg',
        text: 'Singapore',
      },
      {
        id: 'uk',
        text: 'UK',
      },
      {
        id: 'au',
        text: 'Australia',
      },
    ],
  };

  const ssRegions = {
    results: [
      {
        id: 'us',
        text: 'US',
      },
      {
        id: 'au',
        text: 'Australia',
      },
      {
        id: 'uk',
        text: 'UK',
      },
      {
        id: 'sg',
        text: 'Singapore',
      },
    ],
  };

  const sellTypeData = {
    results: [
      {
        id: 'Apparel & Accessories',
        text: 'Apparel & Accessories',
      },
      {
        id: 'Baby Products',
        text: 'Baby Products',
      },
      {
        id: 'Computers & Electronics',
        text: 'Computers & Electronics',
      },
      {
        id: 'Flowers & Gifts',
        text: 'Flowers & Gifts',
      },
      {
        id: 'Furniture & Home Decor',
        text: 'Furniture & Home Decor',
      },
      {
        id: 'Grocery',
        text: 'Grocery',
      },
      {
        id: 'Health & Beauty',
        text: 'Health & Beauty',
      },
      {
        id: 'Jewellery',
        text: 'Jewellery',
      },
      {
        id: 'Mass Merchant',
        text: 'Mass Merchant',
      },
      {
        id: 'Office Supplies',
        text: 'Office Supplies',
      },
      {
        id: 'Sporting Goods',
        text: 'Sporting Goods',
      },
      {
        id: 'Others',
        text: 'Others',
      },
    ],
  };

  const timeZoneData = {
    results: [
      {
        id: 'Pacific/Pago_Pago',
        text: '(GMT-11:00) American Samoa ( SST )',
      },
      {
        id: 'Pacific/Midway',
        text: '(GMT-11:00) Midway Island ( SST )',
      },
      {
        id: 'Pacific/Honolulu',
        text: '(GMT-10:00) Hawaii ( HST )',
      },
      {
        id: 'America/Juneau',
        text: '(GMT-09:00) Alaska ( AKDT )',
      },
      {
        id: 'America/Los_Angeles',
        text: '(GMT-08:00) Pacific Time (US & Canada) ( PDT )',
      },
      {
        id: 'America/Tijuana',
        text: '(GMT-08:00) Tijuana ( PDT )',
      },
      {
        id: 'America/Phoenix',
        text: '(GMT-07:00) Arizona ( MST )',
      },
      {
        id: 'America/Chihuahua',
        text: '(GMT-07:00) Chihuahua ( MDT )',
      },
      {
        id: 'America/Mazatlan',
        text: '(GMT-07:00) Mazatlan ( MDT )',
      },
      {
        id: 'America/Denver',
        text: '(GMT-07:00) Mountain Time (US & Canada) ( MDT )',
      },
      {
        id: 'America/Guatemala',
        text: '(GMT-06:00) Central America ( CST )',
      },
      {
        id: 'America/Chicago',
        text: '(GMT-06:00) Central Time (US & Canada) ( CDT )',
      },
      {
        id: 'America/Mexico_City',
        text: '(GMT-06:00) Mexico City ( CDT )',
      },
      {
        id: 'America/Monterrey',
        text: '(GMT-06:00) Monterrey ( CDT )',
      },
      {
        id: 'America/Regina',
        text: '(GMT-06:00) Saskatchewan ( CST )',
      },
      {
        id: 'America/Bogota',
        text: '(GMT-05:00) Bogota ( -05 )',
      },
      {
        id: 'America/New_York',
        text: '(GMT-05:00) Eastern Time (US & Canada) ( EDT )',
      },
      {
        id: 'America/Indiana/Indianapolis',
        text: '(GMT-05:00) Indiana (East) ( EDT )',
      },
      {
        id: 'America/Lima',
        text: '(GMT-05:00) Lima ( -05 )',
      },
      {
        id: 'America/Halifax',
        text: '(GMT-04:00) Atlantic Time (Canada) ( ADT )',
      },
      {
        id: 'America/Caracas',
        text: '(GMT-04:00) Caracas ( -04 )',
      },
      {
        id: 'America/Guyana',
        text: '(GMT-04:00) Georgetown ( -04 )',
      },
      {
        id: 'America/La_Paz',
        text: '(GMT-04:00) La Paz ( -04 )',
      },
      {
        id: 'America/Santiago',
        text: '(GMT-04:00) Santiago ( -04 )',
      },
      {
        id: 'America/St_Johns',
        text: '(GMT-03:30) Newfoundland ( NDT )',
      },
      {
        id: 'America/Sao_Paulo',
        text: '(GMT-03:00) Brasilia ( -03 )',
      },
      {
        id: 'America/Argentina/Buenos_Aires',
        text: '(GMT-03:00) Buenos Aires ( -03 )',
      },
      {
        id: 'America/Godthab',
        text: '(GMT-03:00) Greenland ( -02 )',
      },
      {
        id: 'America/Montevideo',
        text: '(GMT-03:00) Montevideo ( -03 )',
      },
      {
        id: 'Atlantic/South_Georgia',
        text: '(GMT-02:00) Mid-Atlantic ( -02 )',
      },
      {
        id: 'Atlantic/Azores',
        text: '(GMT-01:00) Azores ( +00 )',
      },
      {
        id: 'Atlantic/Cape_Verde',
        text: '(GMT-01:00) Cape Verde Is. ( -01 )',
      },
      {
        id: 'Africa/Casablanca',
        text: '(GMT+00:00) Casablanca ( +00 )',
      },
      {
        id: 'Europe/Dublin',
        text: '(GMT+00:00) Dublin ( IST )',
      },
      {
        id: 'Europe/London',
        text: '(GMT+00:00) Edinburgh ( BST )',
      },
      {
        id: 'Europe/Lisbon',
        text: '(GMT+00:00) Lisbon ( WEST )',
      },
      {
        id: 'Africa/Monrovia',
        text: '(GMT+00:00) Monrovia ( GMT )',
      },
      {
        id: 'Etc/UTC',
        text: '(GMT+00:00) UTC ( UTC )',
      },
      {
        id: 'Europe/Amsterdam',
        text: '(GMT+01:00) Amsterdam ( CEST )',
      },
      {
        id: 'Europe/Belgrade',
        text: '(GMT+01:00) Belgrade ( CEST )',
      },
      {
        id: 'Europe/Berlin',
        text: '(GMT+01:00) Berlin ( CEST )',
      },
      {
        id: 'Europe/Bratislava',
        text: '(GMT+01:00) Bratislava ( CEST )',
      },
      {
        id: 'Europe/Brussels',
        text: '(GMT+01:00) Brussels ( CEST )',
      },
      {
        id: 'Europe/Budapest',
        text: '(GMT+01:00) Budapest ( CEST )',
      },
      {
        id: 'Europe/Copenhagen',
        text: '(GMT+01:00) Copenhagen ( CEST )',
      },
      {
        id: 'Europe/Ljubljana',
        text: '(GMT+01:00) Ljubljana ( CEST )',
      },
      {
        id: 'Europe/Madrid',
        text: '(GMT+01:00) Madrid ( CEST )',
      },
      {
        id: 'Europe/Paris',
        text: '(GMT+01:00) Paris ( CEST )',
      },
      {
        id: 'Europe/Prague',
        text: '(GMT+01:00) Prague ( CEST )',
      },
      {
        id: 'Europe/Rome',
        text: '(GMT+01:00) Rome ( CEST )',
      },
      {
        id: 'Europe/Sarajevo',
        text: '(GMT+01:00) Sarajevo ( CEST )',
      },
      {
        id: 'Europe/Skopje',
        text: '(GMT+01:00) Skopje ( CEST )',
      },
      {
        id: 'Europe/Stockholm',
        text: '(GMT+01:00) Stockholm ( CEST )',
      },
      {
        id: 'Europe/Vienna',
        text: '(GMT+01:00) Vienna ( CEST )',
      },
      {
        id: 'Europe/Warsaw',
        text: '(GMT+01:00) Warsaw ( CEST )',
      },
      {
        id: 'Africa/Algiers',
        text: '(GMT+01:00) West Central Africa ( CET )',
      },
      {
        id: 'Europe/Zagreb',
        text: '(GMT+01:00) Zagreb ( CEST )',
      },
      {
        id: 'Europe/Athens',
        text: '(GMT+02:00) Athens ( EEST )',
      },
      {
        id: 'Europe/Bucharest',
        text: '(GMT+02:00) Bucharest ( EEST )',
      },
      {
        id: 'Africa/Cairo',
        text: '(GMT+02:00) Cairo ( EET )',
      },
      {
        id: 'Africa/Harare',
        text: '(GMT+02:00) Harare ( CAT )',
      },
      {
        id: 'Europe/Helsinki',
        text: '(GMT+02:00) Helsinki ( EEST )',
      },
      {
        id: 'Asia/Jerusalem',
        text: '(GMT+02:00) Jerusalem ( IDT )',
      },
      {
        id: 'Europe/Kaliningrad',
        text: '(GMT+02:00) Kaliningrad ( EET )',
      },
      {
        id: 'Europe/Kiev',
        text: '(GMT+02:00) Kyiv ( EEST )',
      },
      {
        id: 'Africa/Johannesburg',
        text: '(GMT+02:00) Pretoria ( SAST )',
      },
      {
        id: 'Europe/Riga',
        text: '(GMT+02:00) Riga ( EEST )',
      },
      {
        id: 'Europe/Sofia',
        text: '(GMT+02:00) Sofia ( EEST )',
      },
      {
        id: 'Europe/Tallinn',
        text: '(GMT+02:00) Tallinn ( EEST )',
      },
      {
        id: 'Europe/Vilnius',
        text: '(GMT+02:00) Vilnius ( EEST )',
      },
      {
        id: 'Asia/Baghdad',
        text: '(GMT+03:00) Baghdad ( +03 )',
      },
      {
        id: 'Europe/Istanbul',
        text: '(GMT+03:00) Istanbul ( +03 )',
      },
      {
        id: 'Asia/Kuwait',
        text: '(GMT+03:00) Kuwait ( +03 )',
      },
      {
        id: 'Europe/Minsk',
        text: '(GMT+03:00) Minsk ( +03 )',
      },
      {
        id: 'Europe/Moscow',
        text: '(GMT+03:00) Moscow ( MSK )',
      },
      {
        id: 'Africa/Nairobi',
        text: '(GMT+03:00) Nairobi ( EAT )',
      },
      {
        id: 'Asia/Riyadh',
        text: '(GMT+03:00) Riyadh ( +03 )',
      },
      {
        id: 'Asia/Tehran',
        text: '(GMT+03:30) Tehran ( +0430 )',
      },
      {
        id: 'Asia/Muscat',
        text: '(GMT+04:00) Abu Dhabi ( +04 )',
      },
      {
        id: 'Asia/Baku',
        text: '(GMT+04:00) Baku ( +04 )',
      },
      {
        id: 'Europe/Samara',
        text: '(GMT+04:00) Samara ( +04 )',
      },
      {
        id: 'Asia/Tbilisi',
        text: '(GMT+04:00) Tbilisi ( +04 )',
      },
      {
        id: 'Europe/Volgograd',
        text: '(GMT+04:00) Volgograd ( +04 )',
      },
      {
        id: 'Asia/Yerevan',
        text: '(GMT+04:00) Yerevan ( +04 )',
      },
      {
        id: 'Asia/Kabul',
        text: '(GMT+04:30) Kabul ( +0430 )',
      },
      {
        id: 'Asia/Yekaterinburg',
        text: '(GMT+05:00) Ekaterinburg ( +05 )',
      },
      {
        id: 'Asia/Karachi',
        text: '(GMT+05:00) Karachi ( PKT )',
      },
      {
        id: 'Asia/Tashkent',
        text: '(GMT+05:00) Tashkent ( +05 )',
      },
      {
        id: 'Asia/Kolkata',
        text: '(GMT+05:30) Kolkata ( IST )',
      },
      {
        id: 'Asia/Colombo',
        text: '(GMT+05:30) Sri Jayawardenepura ( +0530 )',
      },
      {
        id: 'Asia/Kathmandu',
        text: '(GMT+05:45) Kathmandu ( +0545 )',
      },
      {
        id: 'Asia/Almaty',
        text: '(GMT+06:00) Almaty ( +06 )',
      },
      {
        id: 'Asia/Dhaka',
        text: '(GMT+06:00) Dhaka ( +06 )',
      },
      {
        id: 'Asia/Urumqi',
        text: '(GMT+06:00) Urumqi ( +06 )',
      },
      {
        id: 'Asia/Rangoon',
        text: '(GMT+06:30) Rangoon ( +0630 )',
      },
      {
        id: 'Asia/Bangkok',
        text: '(GMT+07:00) Bangkok ( +07 )',
      },
      {
        id: 'Asia/Jakarta',
        text: '(GMT+07:00) Jakarta ( WIB )',
      },
      {
        id: 'Asia/Krasnoyarsk',
        text: '(GMT+07:00) Krasnoyarsk ( +07 )',
      },
      {
        id: 'Asia/Novosibirsk',
        text: '(GMT+07:00) Novosibirsk ( +07 )',
      },
      {
        id: 'Asia/Shanghai',
        text: '(GMT+08:00) Beijing ( CST )',
      },
      {
        id: 'Asia/Chongqing',
        text: '(GMT+08:00) Chongqing ( CST )',
      },
      {
        id: 'Asia/Hong_Kong',
        text: '(GMT+08:00) Hong Kong ( HKT )',
      },
      {
        id: 'Asia/Irkutsk',
        text: '(GMT+08:00) Irkutsk ( +08 )',
      },
      {
        id: 'Asia/Kuala_Lumpur',
        text: '(GMT+08:00) Kuala Lumpur ( +08 )',
      },
      {
        id: 'Australia/Perth',
        text: '(GMT+08:00) Perth ( AWST )',
      },
      {
        id: 'Asia/Singapore',
        text: '(GMT+08:00) Singapore ( +08 )',
      },
      {
        id: 'Asia/Taipei',
        text: '(GMT+08:00) Taipei ( CST )',
      },
      {
        id: 'Asia/Ulaanbaatar',
        text: '(GMT+08:00) Ulaanbaatar ( +08 )',
      },
      {
        id: 'Asia/Tokyo',
        text: '(GMT+09:00) Sapporo ( JST )',
      },
      {
        id: 'Asia/Seoul',
        text: '(GMT+09:00) Seoul ( KST )',
      },
      {
        id: 'Asia/Yakutsk',
        text: '(GMT+09:00) Yakutsk ( +09 )',
      },
      {
        id: 'Australia/Adelaide',
        text: '(GMT+09:30) Adelaide ( ACST )',
      },
      {
        id: 'Australia/Darwin',
        text: '(GMT+09:30) Darwin ( ACST )',
      },
      {
        id: 'Australia/Brisbane',
        text: '(GMT+10:00) Brisbane ( AEST )',
      },
      {
        id: 'Australia/Melbourne',
        text: '(GMT+10:00) Canberra ( AEST )',
      },
      {
        id: 'Pacific/Guam',
        text: '(GMT+10:00) Guam ( ChST )',
      },
      {
        id: 'Australia/Hobart',
        text: '(GMT+10:00) Hobart ( AEST )',
      },
      {
        id: 'Pacific/Port_Moresby',
        text: '(GMT+10:00) Port Moresby ( +10 )',
      },
      {
        id: 'Australia/Sydney',
        text: '(GMT+10:00) Sydney ( AEST )',
      },
      {
        id: 'Asia/Vladivostok',
        text: '(GMT+10:00) Vladivostok ( +10 )',
      },
      {
        id: 'Asia/Magadan',
        text: '(GMT+11:00) Magadan ( +11 )',
      },
      {
        id: 'Pacific/Noumea',
        text: '(GMT+11:00) New Caledonia ( +11 )',
      },
      {
        id: 'Pacific/Guadalcanal',
        text: '(GMT+11:00) Solomon Is. ( +11 )',
      },
      {
        id: 'Asia/Srednekolymsk',
        text: '(GMT+11:00) Srednekolymsk ( +11 )',
      },
      {
        id: 'Pacific/Auckland',
        text: '(GMT+12:00) Auckland ( NZST )',
      },
      {
        id: 'Pacific/Fiji',
        text: '(GMT+12:00) Fiji ( +12 )',
      },
      {
        id: 'Asia/Kamchatka',
        text: '(GMT+12:00) Kamchatka ( +12 )',
      },
      {
        id: 'Pacific/Majuro',
        text: '(GMT+12:00) Marshall Is. ( +12 )',
      },
      {
        id: 'Pacific/Chatham',
        text: '(GMT+12:45) Chatham Is. ( +1245 )',
      },
      {
        id: 'Pacific/Tongatapu',
        text: "(GMT+13:00) Nuku'alofa ( +13 )",
      },
      {
        id: 'Pacific/Apia',
        text: '(GMT+13:00) Samoa ( +13 )',
      },
      {
        id: 'Pacific/Fakaofo',
        text: '(GMT+13:00) Tokelau Is. ( +13 )',
      },
    ],
  };


  $('#userDefaultRegion').select2({
    data: ssRegions.results,
    placeholder: 'Data center name',
  }).on('change', () => {
    const value = $('#userDefaultRegion option:selected').text();
    $('.rgn-text').html(`Your site will be hosted in ${value}`);
  });

  $('#userRegion').select2({
    data: data.results,
    placeholder: 'Select a region',
  });

  $.fn.select2.defaults.reset();

  $('#user_time_zone').select2({
    data: timeZoneData.results,
    placeholder: 'Select Time Zone',
  });

  $('#sell_type').select2({
    data: sellTypeData.results,
    placeholder: 'What do you sell?',
  });

  // Validate email id to exclude certain domains
  function isValidMailAddress(email) {
    const match = /^\w+[-\.\w]*@(\w+[-\.\w]*?\.\w{2,4})$/.exec(email);
    if (!match) {
      return false;
    }

    const forbiddenDomains = ['unbxd.com'];
    if (forbiddenDomains.indexOf(match[1].toLowerCase()) >= 0) {
      $('#submit_signup_form').prop('disabled', true);
      $('#user_signup_email').parent().addClass('has-error');
      return false;
    }

    $('#user_signup_email').parent().removeClass('has-error');
    $('#submit_signup_form').prop('disabled', false);
    return true;
  }

  $('#user_signup_email').on('change', () => {
    const userEmail = $('#user_signup_email').val();
    isValidMailAddress(userEmail);
  });


  // Validate Password and ConfirmPassword mismatch
  function doesPasswordMatch() {
    const password = $('#user_password').val();
    const confirmPassword = $('#user_password_confirmation').val();
    if (password !== confirmPassword) {
      $('#submit_signup_form').prop('disabled', true);
      $('#user_password_confirmation').parent().addClass('has-error');
      return false;
    }
    $('#submit_signup_form').prop('disabled', false);
    $('#user_password_confirmation').parent().removeClass('has-error');
    return true;
  }

  $('#user_password_confirmation, #user_password').on('change', () => {
    doesPasswordMatch();
  });

  // Close error alert
  $('.anyErrorClose').on('click', () => {
    $('.anyErrorClose').parent().removeClass('d-block');
  });

  //  convert an image to a Base64 string
  $('#user_avatar').on('change', (event) => {
    const img = $('#user_avatar');
    let imgtag = $('#profile-avatar');
    const ua = window.navigator.userAgent;
    const msie = ua.indexOf('MSIE ');

    const path = img.val();
    const ext = path.substring(path.lastIndexOf('.') + 1).toLowerCase();

    if (ext === 'gif' || ext === 'jpeg' || ext === 'jpg' || ext === 'png') {
      if (msie > 0) {
        imgtag.attr('src', path);
      } else {
        imgtag.css('display', 'block');
        const selectedFile = event.target.files[0];
        const reader = new FileReader();
        if (selectedFile.size < 2000000) {
          imgtag = imgtag.get(0);
          imgtag.title = 'add file';
          reader.onload = function (e) {
            imgtag.src = e.target.result;
          };
          reader.readAsDataURL(selectedFile);
        } else {
          alert('image size should be less than 2mb');
          imgtag.css('display', 'none');
        }
      }
    } else {
      imgtag.css('display', 'none');
    }

    setTimeout(() => {
      const base64String = $('#profile-avatar').attr('src') || '';
      $('#convertedImg').attr('value', base64String.substring(base64String.indexOf(',') + 1));
    }, 1000);
  });
});
